import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { PartGroup } from '../../../interface/part-group';
import { PartSubgroup } from '../../../interface/part-subgroup';
import { GroupService } from '../../../service/group.service';
import { LayoutService } from '../../../service/layout.service';
import { SnackbarService } from '../../../service/snackbar.service';
import { SubgroupService } from '../../../service/subgroup.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { SingleClickDirective } from 'src/app/shared/directives/single-click.directive';
import { MatButton } from '@angular/material/button';
import { MoneyDirective } from 'src/app/shared/directives/money.directive';
import { MatInput } from '@angular/material/input';

@Component({
  selector: 'app-subgroup-edit',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,

    TranslateModule,
    SingleClickDirective,
    MoneyDirective,

    MatDialogTitle,
    MatDialogContent,
    MatFormFieldModule,
    MatInput,
    MatSelect,
    MatOption,
    MatDialogActions,
    MatButton,
  ],
  templateUrl: './subgroup-edit.component.html',
  styleUrl: './subgroup-edit.component.scss'
})
export class SubgroupEditComponent implements OnInit {

  form: FormGroup;
  subgroup: PartSubgroup

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      subgroup?: PartSubgroup,
      group?: PartGroup,
      partGroups?: PartGroup[]
    },
    private dialogRef: MatDialogRef<SubgroupEditComponent>,
    private formBuilder: FormBuilder,
    public groupService: GroupService,
    private subgroupService: SubgroupService,
    private layout: LayoutService,
    private snackbar: SnackbarService
  ) {
    if (data) {
      this.subgroup = data.subgroup
    }
  }

  displayGroup = (group?: PartGroup) => {
    return group && group.description ? group.description : "";
  }

  ngOnInit() {
    this.buildForm()
  }

  buildForm() {
    if (this.subgroup) {
      this.form = this.formBuilder.group({
        _id: this.subgroup._id,
        description: [this.subgroup.description, Validators.required],
        salePricePercentage: [this.subgroup.salePricePercentage, Validators.required],
        group: this.data.group || ''
      })
    } else {
      this.form = this.formBuilder.group({
        _id: '',
        description: ["", Validators.required],
        salePricePercentage: ["", Validators.required],
        group: this.data.group || ""
      })
    }
  }

  async onSubmit() {
    let subgroup: PartSubgroup = this.form.getRawValue();
    const isUpdate = Boolean(subgroup._id);
    try {
      this.layout.loader = true;
      if (isUpdate) {
        await this.subgroupService.update(subgroup)
      } else {
        const id = await this.subgroupService.register(subgroup);
        subgroup._id = id;
      }
      this.snackbar.success(isUpdate ? 'SUBGROUP.UPDATED' : 'SUBGROUP.ADDED');
    } catch (error) {
      console.error("Falha ao registrar subgrupo\n\n", error)
      this.snackbar.error(isUpdate ? 'SUBGROUP.NOT_UPDATED' : 'SUBGROUP.NOT_ADDED', null, error);
    } finally {
      this.layout.loader = false;
    }

    this.dialogRef.close(subgroup);
  }

  close() {
    this.dialogRef.close(null);
  }

}
